import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Defense-in-depth role gate. The backend already rejects non-Studio roles at
 * login, but this ensures a session that somehow carries a disallowed role
 * cannot reach protected routes. Signs the user out and returns to /login.
 */
export const studioRoleGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated() && auth.hasStudioAccess()) {
    return true;
  }

  auth.logout();
  return router.createUrlTree(['/login'], {
    queryParams: { denied: '1' },
  });
};
